(() => {
  const key = 'rosvia:wishlist';
  let saved = new Set();
  const read = () => { try { const values = JSON.parse(localStorage.getItem(key) || '[]'); saved = new Set(Array.isArray(values) ? values.map(String) : []); } catch { saved = new Set(); } };
  const sync = () => {
    document.querySelectorAll('[data-wishlist]').forEach(button => button.setAttribute('aria-pressed', String(saved.has(button.dataset.wishlist))));
    document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = saved.size; });
  };
  read(); sync();
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-wishlist]'); if (!button) return;
    e.preventDefault();
    const id = button.dataset.wishlist;
    if (saved.has(id)) saved.delete(id); else saved.add(id);
    try {
      localStorage.setItem(key, JSON.stringify([...saved]));
      // The wishlist page loads products by handle (the storefront cannot look them up by id).
      const handles = JSON.parse(localStorage.getItem(`${key}-handles`) || '{}');
      if (button.dataset.wishlistHandle) handles[id] = button.dataset.wishlistHandle;
      Object.keys(handles).forEach(saved_id => { if (!saved.has(saved_id)) delete handles[saved_id]; });
      localStorage.setItem(`${key}-handles`, JSON.stringify(handles));
    } catch {}
    sync();
  });
  addEventListener('storage', e => { if (e.key === key) { read(); sync(); } });
  document.addEventListener('products:rendered', sync);
  // The wishlist page can clear every saved product at once.
  document.addEventListener('wishlist:changed', () => { read(); sync(); });
  document.addEventListener('shopify:section:load', sync);
})();
